import { useSelector } from 'react-redux';

import { Icon, Tooltip } from '@components';
import CurrencyAmount from '@components/currency-amount/CurrencyAmount';
import { DEFAULT_CURRENCY_CONFIG } from '@hooks/useCurrency';

import theme from '../../../../../themes/colors';
import { TransactionStatus } from '../../constants';

interface AmountTagProps {
  status: TransactionStatus;
  amount: string;
  isSplitPayment: boolean;
  isDisabled: boolean;
  id: string;
}

const AmountTag = ({
  status,
  amount,
  isSplitPayment,
  isDisabled,
  id
}: AmountTagProps) => {
  const { currencyConfig } = useSelector((state: any) => state.user);

  const isDefaultCurrency =
    currencyConfig?.code === DEFAULT_CURRENCY_CONFIG.code;

  const progressColors = {
    [TransactionStatus.DISABLED]: {
      textColor: 'text-cofeeNeutral6', // grey
      bgColor: 'bg-grey10',
      iconColor: undefined
    },
    [TransactionStatus.TO_SETTLE]: {
      textColor: '!text-blue1', // blue
      bgColor: 'bg-blue',
      iconColor: theme.blue1
    },
    [TransactionStatus.SETTLED]: {
      textColor: 'text-primary40', // green
      bgColor: 'bg-primary10',
      iconColor: theme.primary40
    },
    [TransactionStatus.PROCCESSING]: {
      textColor: 'text-cofeeOrange6', // yellow
      bgColor: 'bg-cofeeOrange2',
      iconColor: theme.cofeeOrange6
    },
    [TransactionStatus.DEFAULT]: {
      textColor: 'text-content',
      bgColor: 'bg-white',
      iconColor: theme.content
    }
  };

  return (
    <div className="flex items-center gap-2.5">
      <div
        className={`flex h-8.5 min-w-24 items-center justify-center rounded-lg ${progressColors[status].bgColor} px-2`}
      >
        {progressColors[status].iconColor ? (
          <CurrencyAmount
            value={amount}
            className={`${progressColors[status].textColor} ${
              isDefaultCurrency ? 'gap-0.25' : 'gap-0.5'
            }`}
            symbolClass={`${
              isDefaultCurrency ? 'text-[0.95em] !font-normal' : ''
            }`}
            valueClass="font-medium"
          />
        ) : (
          <div className="text-sm font-normal">Disabled</div>
        )}
      </div>
      {isSplitPayment && (
        <>
          <Icon
            name="split-payment"
            size="none"
            className="size-4"
            stroke={
              isDisabled ? theme.cofeeNeutralInactive : theme.cofeeOrange6
            }
            data-tooltip-id={`split-icon-${id}`}
          />
          <Tooltip
            id={`split-icon-${id}`}
            type="text"
            tooltipText="Partial Payment"
          />
        </>
      )}
    </div>
  );
};

export default AmountTag;
